angular
    .module('app')
    .component('segmentsEdit', {
        templateUrl: '/templates/pages/segments/segmentsEdit/segmentsEdit.html',
        controller: 'SegmentsEditController',
        controllerAs: 'vm',
    });